import { atlas } from 'graphql/tags'

export const SET_SELECTED_ACCOUNT_MUTATION = atlas`#graphql
mutation SetSelectedAccountMutation($input: SetSelectedAccountInput!) {
    setSelectedAccount(input: $input) {
        success
        error
    }
}`
